export const taskStatusList = {
  TASK_ALL_FINISH: {
    label: '成功',
    value: 'TASK_ALL_FINISH'
  },
  TASK_FAIL: {
    label: '失败',
    value: 'TASK_FAIL'
  },
  TASK_EXECUTE: {
    label: '执行中',
    value: 'TASK_EXECUTE'
  },
  TASK_PART_FINISH: {
    label: '部分成功',
    value: 'TASK_PART_FINISH'
  }
}
